var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-inline d-inline"},[(_vm.agendaSurat.loading)?_c('div',{staticClass:"text-center form-inline d-inline"},[_c('b-spinner'),_c('span',[_vm._v("Loading...")])],1):_c('b-badge',{staticClass:"mr-1 text-with",attrs:{"variant":"info"}},[_vm._v(" "+_vm._s(_vm.cabangAdminGetters)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }